<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="890">
      <v-card>
        <v-card-title>พนักงาน</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            clearable
            single-line
            placeholder="รหัส - ชื่อพนักงาน"
            @input="handleSearch"
          ></v-text-field>
          <v-data-table
            v-model="selected"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            :loading="loading"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="employees"
            :options.sync="options"
            :server-items-length="totalEmployees"
            :items-per-page="5"
            show-select
            :single-select="singleSelect"
            item-key="employee_uuid"
            class="elevation-1"
            :footer-props="{
              itemsPerPageText: 'Rows per page:',
              disableItemsPerPage: true,
            }"
            height="288"
            must-sort
          >
            <template v-slot:item.firstname_th="{ item }">
              {{ item.firstname_th }} {{ item.lastname_th }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-btn color="primary" depressed @click="onSubmit" :disabled="loading"
            >ตกลง
          </v-btn>
          <v-btn depressed @click="onCancel" :disabled="loading">ยกเลิก</v-btn>
          <v-btn icon @click="onRefresh" :disabled="loading"
            ><v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

export default {
  name: 'EmployeeListDialog',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    singleSelect: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      options: {},
      sortBy: ['employee_code'],
      sortDesc: [false],
      search: '',
      selected: [],
      headers: [
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          width: 140,
          value: 'employee_code',
        },
        { text: 'ชื่อพนักงาน', value: 'firstname_th' },
        {
          text: 'หน่วยงาน',
          width: 180,
          value: 'organization.title_th',
        },
        {
          text: 'ตำแหน่ง',
          width: 180,
          value: 'position.title_th',
        },
      ],
    }
  },
  watch: {
    options: {
      handler() {
        this.getEmployees()
      },
      deep: true,
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    employees() {
      return this.$store.state.employee.employees
    },
    totalEmployees() {
      return this.$store.state.employee.totalEmployees
    },
  },
  methods: {
    ...mapActions({
      fetchEmployees: 'employee/fetchEmployees',
    }),
    handleSearch() {
      this.loading = true
      this.getEmployeesBySearch()
    },

    getEmployeesBySearch: _.debounce(function () {
      this.options.page = 1
      this.getEmployees()
    }, 1000),

    getEmployees() {
      this.loading = true

      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      const sortKey = [...sortBy]

      if (sortKey[0] === 'organization.title_th') {
        sortKey[0] = 'organization_th'
      } else if (sortKey[0] === 'position.title_th') {
        sortKey[0] = 'position_th'
      }

      const sortParams = sortKey
        .map((field, i) => `${field}:${sortDesc[i] ? 'desc' : 'asc'}`)
        .join(',')

      const { company_uuid } = this.$store.state.authentication.company

      let dpc = ''
      const routeName = this.$route.name
      if (routeName === 'UserRoleList') {
        dpc = 'role-to-list-employee'
      } else if (routeName === 'Organization') {
        dpc = 'organization-to-list-employee'
      } else if ('LeaveApprover') {
        dpc = 'leave-approver-to-list-employee'
      }

      const payload = {
        company_uuid,
        params: {
          dpc,
          search: this.search || undefined,
          is_active: true,
          sort: sortParams || undefined,
          limit: itemsPerPage,
          offset: (page - 1) * itemsPerPage,
        },
      }
      this.fetchEmployees(payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.selected.length === 0) {
        const snackbar = {
          show: true,
          color: 'warning',
          timeout: 4000,
          message: 'ไม่ได้เลือกพนักงาน',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      } else {
        this.$emit('submitEmployeeListDialog', this.selected)
        this.search = ''
        this.selected = []
      }
    },
    onCancel() {
      this.$emit('cancelEmployeeListDialog')
      this.search = ''
      this.selected = []
    },
    onRefresh() {
      this.getEmployees()
    },
  },
}
</script>
